module.exports = __webpack_public_path__ + "static/media/externalBarn_13.421deeb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_13.png
// module id = 1301
// module chunks = 3